import { Route, BrowserRouter as Router, Routes } from "react-router-dom";

import Home from "./pages/home";
import PartnerMainPage from "./pages/partnerMainPage";
import PartnerFormPage from "./pages/partnerForm";
import PrivacyTerms from "./pages/privacyTerms";
import FAQ from "./pages/faq";

const MyRoutes = () => {
    return (
        <Router>
            <Routes>
                <Route path="/" element={<Home/>} />
                <Route path="/seja-parceiro" element={<PartnerMainPage/>} />
                <Route path="/seja-parceiro/formulario" element={<PartnerFormPage/>} />
                <Route path="/termos-de-privacidade" element={<PrivacyTerms/>} />
                <Route path="/faq" element={<FAQ/>} />
            </Routes>
        </Router>
    )
}

export default MyRoutes;